import Button from '../ui-components/Button'
import ButtonControl from '../button-control'

const reloadPage = () => {
  window.location.reload()
}

const Header = ({
  title,
  saveCallback,
  cancelCallback,
  isLoading,
  hasBreadcrumb,
  breadcrumbLink,
  breadcrumbText,
  disableCancelButton,
  disableSaveButton,
  customButtons
}) => {
  if (typeof cancelCallback === 'undefined') {
    cancelCallback = reloadPage
  }

  const headerClass = `control-header${hasBreadcrumb ? ' control-header--breadcrumb' : ''}`

  return (
    <div class={headerClass}>
      <div class='control-header__texts-container'>
        {
          hasBreadcrumb && (
            <span class='control-header__breadcrumb'>
              <i class='fa fa-chevron-left' />
              <a class='control-header__breadcrumb-link' href={breadcrumbLink}>{breadcrumbText}</a>
            </span>
          )
        }
        <h2 class='control-header__title'>{title}</h2>
      </div>
      <div class='control-header__buttons'>
        {
          !disableCancelButton && (
            <Button
              default
              title={'Cancel'}
              onClick={() => cancelCallback()}
              style={{ marginRight: '10px' }}
              qaClasses={'js-cancel'}
            />
          )
        }
        {
          !disableSaveButton && (
            <Button
              success
              title={'Save'}
              onClick={() => saveCallback()}
              disabled={isLoading}
              loading={isLoading}
              qaClasses={'js-submit'}
            />
          )
        }
        {(customButtons && customButtons.length)
          ? customButtons[0].nodeName
            ? customButtons
            : customButtons.map(({
              url,
              customClass,
              variant,
              title,
              action
            }) => {
              if (!action && !url) return null

              return (
                <a class='control-header__button-wrapper' href={url}>
                  <ButtonControl
                    variant={variant}
                    class={customClass}
                    title={title}
                    onClick={action}
                  />
                </a>
              )
            })
          : null}
      </div>
    </div>
  )
}

export default Header
